import { useDetailsBooking } from 'lib/hooks';
import { AvailableStay, useAvailabilityCalendarQuery } from 'lib/graphql';
import { addYears, endOfDay, startOfDay, parseISO } from 'date-fns';
import { toCalendarDateFormat } from 'lib/utils';

export const useAvailabilityCalendar = () => {
  const { booking } = useDetailsBooking();

  const minDate = startOfDay(new Date());
  const maxDate = addYears(endOfDay(new Date()), 1);

  const { data } = useAvailabilityCalendarQuery({
    variables: {
      bookingId: booking.id,
      startDate: toCalendarDateFormat(minDate),
      endDate: toCalendarDateFormat(maxDate),
    },
  });

  const loading = !data;
  const blockedDates = getBlockedDates(data);

  return {
    loading,
    minDate,
    maxDate,
    blockedDates,
  };
};

const getBlockedDates = (data: any) => {
  if (!data?.availabilityCalendar?.stays) {
    return [];
  }

  return data?.availabilityCalendar.stays.reduce((blocked: Date[], stay: AvailableStay) => {
    if (!stay.available) {
      blocked.push(startOfDay(parseISO(stay.checkIn)));
    }

    return blocked;
  }, []);
};
